import { DataTestId, isZeroSimpleAmount, LocalizedCurrencySimpleValue, SimpleAmount } from '@mews-distributor/common';
import { LocalizedText, useToggle } from '@mews/framework';
import { TextKey } from '@mews/text-keys';
import { Clickable, ExpandIcon, Stack, StackItem, Typography } from '@optimus-web/core';
import { ExpandableBox } from '@optimus-web/helpers';

import { ProductOrder, ProductOrderProps } from './ProductOrder';

interface ProductsBreakdownProps {
    items: ProductOrderProps[];
    productsTotalPrice: SimpleAmount;
}

export const ProductsBreakdown = ({ productsTotalPrice, items }: ProductsBreakdownProps) => {
    const [expanded, toggleExpanded] = useToggle({ initialValue: true });

    if (items.length === 0) {
        return null;
    }

    return (
        <StackItem>
            <Stack spacing="200" distribution="space-between">
                <Clickable onClick={toggleExpanded} data-test-id={DataTestId.ToggleExpandableBox} type="button">
                    <Stack spacing="200" distribution="space-between">
                        <Typography textStyle="bodyMediumStrong" as="div">
                            <LocalizedText textKey={TextKey.ProductsAndExtras} />
                            <ExpandIcon expanded={expanded} />
                        </Typography>
                    </Stack>
                </Clickable>
                <Typography textStyle="bodyMediumStrong" as="div">
                    {isZeroSimpleAmount(productsTotalPrice) ? null : (
                        <LocalizedCurrencySimpleValue value={productsTotalPrice} />
                    )}
                </Typography>
            </Stack>
            <ExpandableBox expanded={expanded}>
                {items.map((item) => (
                    <ProductOrder {...item} key={item.id} />
                ))}
            </ExpandableBox>
        </StackItem>
    );
};
